import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Links, MessageResponse } from 'app/auth/models/message-response.model';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    standalone: false
})
export class MessageComponent implements OnInit {

    public message: MessageResponse | null = null;

    constructor(
        private route: ActivatedRoute,
        private location: Location,
        private router: Router
    ) { }

    ngOnInit() {
        this.setup();
    }

    public setup(): void {
        try {
            var response = this.route.snapshot.queryParams['message'];
            this.message = JSON.parse(response);

            const url = new URL(window.location.href);
            url.searchParams.delete('message');
            window.history.replaceState({}, '', url.toString());

        } catch (error) {
            if (window.history.length > 1) {
                this.location.back();
            } else {
                this.router.navigate(['/login']);
            }
        }
    }

    public open(link: Links): void {
        if (link.retry) {
            window.location.href = link.url;
        } else {
            window.open(link.url, '_blank');
        }
    }
}
